export default "__VITE_ASSET__2qntJj1I__"